import { jsxs as me, jsx as i, Fragment as ht } from "react/jsx-runtime";
import { useMemo as et, useRef as J, useEffect as re, useState as Le, forwardRef as tt, useLayoutEffect as ut } from "react";
import { u as b } from "./index-6a632112.mjs";
import { useAccessibilityProps as pt } from "./accessibility.js";
import { a as pe, Q as fe, s as k, r as A, b as K, f as be, e as ge } from "./themes-5f0b3c3d.mjs";
import { l as nt } from "./lineHeights-72d3110c.mjs";
import { ScreenReaderOnly as ft } from "./screenReaderOnly.js";
import { TextInput as gt } from "./textInput.js";
import { S as Ke } from "./types-b577bf77.mjs";
import { S as yt } from "./cancelCloseFilled-b2127cb6.mjs";
import { u as bt } from "./uniqueId-321287e8.mjs";
import { g as je } from "./getElementPosition-5026bb28.mjs";
import { useWindowDimensions as xt } from "./useWindowDimensions.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./zIndices-d07533f3.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
function wt({
  title: e,
  titleId: t,
  size: n,
  height: o,
  width: s,
  ...p
}) {
  const f = n ? Ke[n] : Ke.s;
  return /* @__PURE__ */ me(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: n ? f : o || f,
      width: n ? f : s || f,
      "aria-labelledby": t,
      ...p,
      children: [
        e ? /* @__PURE__ */ i("title", { id: t, children: e }) : null,
        /* @__PURE__ */ i("g", { clipPath: "url(#Calendar_svg__a)", children: /* @__PURE__ */ i(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M21.6 12.6V5.4c0-1.08.72-1.8 1.8-1.8s1.8.72 1.8 1.8v7.2c0 .9-.9 1.8-1.8 1.8-1.08 0-1.8-.9-1.8-1.8Zm43.2-1.8v54H7.2v-54H18v1.8c0 2.88 2.52 5.4 5.4 5.4 3.06 0 5.4-2.52 5.4-5.4v-1.8h14.4v1.8c0 2.88 2.52 5.4 5.4 5.4 3.06 0 5.4-2.52 5.4-5.4v-1.8h10.8Zm-54 14.4h50.4v36H10.8v-36Zm37.8-10.8c1.08 0 1.8-.9 1.8-1.8V5.4c0-1.08-.9-1.8-1.8-1.8-1.08 0-1.8.72-1.8 1.8v7.2c0 .9.9 1.8 1.8 1.8ZM36.54 30.06h3.06V57.6h-4.14V34.38l-6.12 2.88-1.62-3.24 8.82-3.96Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "Calendar_svg__a", children: /* @__PURE__ */ i("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const Ct = 100, Dt = 50, ue = "SINGLE_DATE", De = "RANGE", Ce = "MUTLI_DATE", Ae = (e, t) => Array.from(Array(e).keys()).map((n) => ({
  value: n + 1,
  id: `${t}-${n}`
})), ee = (e, t) => !e || !t ? !1 : e.day === t.day && e.month === t.month && e.year === t.year, xe = (e) => ({ ...e }), St = (e) => JSON.parse(
  JSON.stringify(
    e,
    (t, n) => typeof n > "u" ? null : n
  )
), Be = (e, t) => {
  const n = t === "NEXT" ? 1 : -1;
  let o = e.month + n, s = e.year;
  return o < 1 && (o = 12, s -= 1), o > 12 && (o = 1, s += 1), { year: s, month: o, day: 1 };
}, we = (e, t) => Object.prototype.hasOwnProperty.call(e || {}, t), ye = (e) => {
  if (Array.isArray(e))
    return Ce;
  if (we(e, "from") && we(e, "to"))
    return De;
  if (!e || we(e, "year") && we(e, "month") && we(e, "day"))
    return ue;
  throw new TypeError(
    "The passed value is malformed! Please make sure you're using one of the valid value types for date picker."
  );
}, kt = (e) => e && e[0].toUpperCase() + e.slice(1) || "", vt = {
  weekStartingIndex: 0,
  getToday(e) {
    return e;
  },
  toNativeDate(e) {
    return new Date(e.year, e.month - 1, e.day);
  },
  getMonthLength(e) {
    return new Date(e.year, e.month, 0).getDate();
  },
  transformDigit(e) {
    return e;
  },
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  from: "from",
  to: "to",
  defaultPlaceholder: "MM / DD / YYYY",
  defaultLabel: "Select Date",
  digitSeparator: ",",
  yearLetterSkip: 0,
  isRtl: !1
}, $t = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], _t = (e = "en-US", t = "long") => {
  const n = new Intl.DateTimeFormat(e, {
    month: t,
    timeZone: "America/Los_Angeles"
  }).format;
  return $t.map(
    (o) => kt(n(new Date(Date.UTC(2021, (o + 1) % 12))))
  );
}, Et = [0, 1, 2, 3, 4, 5, 6], Mt = (e = "es-US", t = "long") => {
  const n = new Intl.DateTimeFormat(e, {
    weekday: t,
    timeZone: "America/Los_Angeles"
  }).format;
  return Et.map((o) => {
    const s = n(new Date(Date.UTC(2021, 10, o + 1)));
    return {
      name: n(new Date(Date.UTC(2021, 10, o + 1))),
      short: s.charAt(0).toUpperCase(),
      isWeekend: o === 0 || o === 6
    };
  });
}, ot = (e) => typeof e == "string" ? {
  months: _t(e),
  weekDays: Mt(e),
  ...vt
} : e, Tt = (e = "en_US") => {
  const {
    months: t,
    getToday: n,
    toNativeDate: o,
    getMonthLength: s,
    weekStartingIndex: p,
    transformDigit: f
  } = typeof e == "string" ? ot(e) : e;
  return {
    getToday: () => {
      const l = /* @__PURE__ */ new Date(), y = l.getFullYear(), x = l.getMonth() + 1, N = l.getDate();
      return n({ year: y, month: x, day: N });
    },
    getMonthName: (l) => t[l - 1],
    getMonthNumber: (l) => t.indexOf(l) + 1,
    getMonthLength: s,
    getMonthFirstWeekday: (l) => (o({ ...l, day: 1 }).getDay() + p) % 7,
    isBeforeDate: (l, y) => !l || !y ? !1 : o(l) < o(y),
    checkDayInDayRange: ({ day: l, from: y, to: x }) => {
      if (!l || !y || !x)
        return !1;
      const N = o(l), z = o(y), a = o(x);
      return N > z && N < a;
    },
    getLanguageDigits: f
  };
}, Se = (e) => et(() => Tt(e), [e]), ke = (e) => et(() => ot(e), [e]), rt = ({
  parent: e,
  isInitialActiveChild: t,
  activeDate: n,
  monthChangeDirection: o
}) => {
  if (!e)
    return t ? n : Be(n, "NEXT");
  const s = e.children[t ? 0 : 1];
  return s.classList.contains("-shown") || s.classList.contains("-shownAnimated") ? n : Be(n, o);
}, at = ({ parent: e, direction: t }) => {
  const n = Array.from(e.children), o = n.find(
    (c) => c.classList.contains("-shown")
  ), s = n.find((c) => c !== o), p = t === "NEXT", f = (c) => c ? "-hiddenNext" : "-hiddenPrevious";
  s.style.transition = "none", o.style.transition = "", o.classList.remove(f(p)), o.classList.add(f(!p)), o.classList.remove("-shown"), s.classList.remove(f(!p)), s.classList.add(f(p)), s.classList.add("-shownAnimated");
}, Fe = ({ target: e }) => {
  e.classList.remove("-hiddenNext"), e.classList.remove("-hiddenPrevious"), e.classList?.replace("-shownAnimated", "-shown");
}, At = b.div`
  display: flex;
  padding: 0;
  align-items: center;
  // overflow: hidden;
  font-size: ${pe.xsmall};

  @media ${fe.mobile} {
    padding: ${k["2x"]} 0;
  }
`, qe = b.button`
  line-height: 0;
  padding: ${k["2x"]};
  position: relative;
  border: none;
  z-index: 1;
  opacity: 1;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
  background: transparent;

  &:disabled,
  &.-hidden {
    opacity: 0;
    pointer-events: none;
  }

  &.-left {
    transform: rotate(90deg);
  }

  &.-right {
    transform: rotate(-90deg);
  }

  &:active .Calendar__monthArrow {
    transform: scale(0.5);
  }

  &.-hidden {
    visibility: hidden;
  }

  &:focus-visible {
    border-radius: ${A["1x"]};
    border: ${K["1x"]} solid
      ${(e) => e.theme.components.datePicker.borderColorDayHover};
  }

  &:hover {
    border-radius: ${A["2x"]};
    background: ${(e) => e.$isMonthSelectorOpen || e.$isYearSelectorOpen ? e.theme.components.datePicker.closeIconHoverBackground : e.theme.components.datePicker.caretIconHoverBackground};
  }
`, Ge = b.span`
  border-radius: 50%;
  transition: transform var(--animation-duration);
  pointer-events: none;
  background-repeat: no-repeat;
  display: block;
  width: ${k["6x"]};
  height: ${k["6x"]};
  transform: scale(0.7);
  background-size: 100% 100%;

  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='24px' height='24px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EFA260AAA-1502-4EAB-86E3-4B374E60AA67%3C/title%3E%3Cg id='General-System' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='GeneralSystems/Caret/Up/Primary/48' fill='%23${(e) => e.theme.components.datePicker.fillMonthArrow}'%3E%3Cpolygon id='CaretUp' points='24 11 0 34.2608957 2.82613808 37 24 16.482116 45.1698303 37 48 34.2608957'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

  &.closeIcon {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='32px' height='32px' viewBox='0 0 32 32' version='1.1'%3E%3Ctitle%3E878BE646-AA54-4813-B533-4CD74F9E23CE%3C/title%3E%3Cg id='General-System' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='GeneralSystems/CloseRemove/Primary/32' fill='%23${(e) => e.theme.components.datePicker.fillMonthYearClose}'%3E%3Cpolygon id='CloseRemove' points='28.8774441 1 16 13.8774441 3.12255594 1 1 3.11953235 13.8804676 16.0030236 1 28.8804676 3.12255594 31 16 18.1225559 28.8774441 31 31 28.8804676 18.1195324 16.0030236 31 3.11953235'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
`, Pt = b.div`
  flex: 1;
  position: relative;
`, Nt = b.div`
  font-size: 11px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  will-change: transform, opacity;
  backface-visibility: hidden;
  transform: translateZ(0);
  transition: opacity var(--animation-duration),
    transform var(--animation-duration);
  line-height: 1;

  > * {
    padding: 0.2em 0.5em;
    border: 1px solid transparent;
    transition: transform var(--animation-duration);
    font-size: 1.05em;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(0) scale(1);
    will-change: transform;
    border-radius: 5px;
  }

  &.-hiddenNext {
    opacity: 0;
    transform: translateX(50%);
  }

  &.-hiddenPrevious {
    opacity: 0;
    transform: translateX(-150%);
  }

  &.-shown {
    opacity: 1;
    margin-top: auto;
    margin-bottom: auto;
    transform: translateX(-50%);
  }

  &.-shownAnimated {
    animation: var(--animation-duration) fadeTextToCenter forwards;
  }

  &:not(.-shown) > *,
  > *.-hidden {
    cursor: default;
    pointer-events: none;
  }

  .Calendar__yearText.-hidden {
    transform: translateX(50%);
    opacity: 0;
  }

  .Calendar__monthText.-hidden {
    transform: translateX(-50%);
    opacity: 0;
  }

  &:not(.-shown) > * {
    pointer-events: none;
  }
`, Lt = b.button`
  font-size: ${pe.small};
  font-family: ${be.inter}, 'SemiBold';
  color: ${(e) => e.theme.components.datePicker.textColorMonthYear};
  background: transparent;
  padding: var(--semantic-spacing-1-x, ${k["1x"]})
    var(--semantic-spacing-6-x, ${k["6x"]});

  border-radius: ${A["2x"]};
  border-width: ${K["2x"]};
  margin-right: 5px;
  font-weight: ${ge.medium.M.fontWeight};
  line-height: ${nt.medium};

  &:hover:not(.notSelected),
  &:focus:not(.notSelected),
  &.selected {
    cursor: pointer;
    border-color: ${(e) => e.theme.components.datePicker.borderColorMonthYearHover};
  }
`, Yt = b.button`
  font-size: ${pe.small};
  font-family: ${be.inter}, 'SemiBold';
  color: ${(e) => e.theme.components.datePicker.textColorMonthYear};
  background: transparent;
  padding: var(--semantic-spacing-1-x, ${k["1x"]})
    var(--semantic-spacing-6-x, ${k["6x"]});

  border-radius: ${A["2x"]};
  border-width: ${K["2x"]};
  margin-right: 5px;
  font-weight: ${ge.medium.M.fontWeight};
  line-height: ${nt.medium};

  border-width: ${K["2x"]};

  &:last-child {
    margin-right: -0.3em;
  }

  &:hover:not(.notSelected),
  &:focus:not(.notSelected),
  &.selected {
    cursor: pointer;
    border-color: ${(e) => e.theme.components.datePicker.borderColorMonthYearHover};
  }
`, Wt = ({
  maximumDate: e,
  minimumDate: t,
  onMonthChange: n,
  activeDate: o,
  monthChangeDirection: s,
  onMonthSelect: p,
  onYearSelect: f,
  isMonthSelectorOpen: c,
  isYearSelectorOpen: g,
  locale: v,
  selectorStartingYear: I,
  selectorEndingYear: $
}) => {
  const F = J(null), l = J(null), { getMonthName: y, isBeforeDate: x, getLanguageDigits: N } = Se(v), {
    isRtl: z,
    nextMonth: a,
    previousMonth: P,
    openMonthSelector: R,
    closeMonthSelector: U,
    openYearSelector: ae,
    closeYearSelector: q
  } = ke(v);
  re(() => {
    s && at({
      direction: s,
      parent: l.current
    });
  }, [s]), re(() => {
    const h = c || g, C = F.current.querySelector(
      ".Calendar__monthYear.-shown .Calendar__monthText"
    ), _ = C.nextSibling, Y = (ne) => ne.classList.contains("-activeBackground");
    if (!h && !Y(C) && !Y(_))
      return;
    const u = c || Y(C), W = u ? C : _, j = u ? _ : C, V = F.current.querySelector(
      ".Calendar__monthArrowWrapper.-right"
    ), X = F.current.querySelector(
      ".Calendar__monthArrowWrapper.-left .Calendar__monthArrow"
    );
    h ? V.classList.add("-hidden") : V.classList.remove("-hidden"), X.classList.toggle("closeIcon"), W.classList.toggle("selected"), j.classList.toggle("notSelected"), W.classList.toggle("-activeBackground"), V.classList.contains("-hidden") ? (V.removeAttribute("aria-hidden"), V.setAttribute("tabindex", "0")) : (V.setAttribute("aria-hidden", !0), V.setAttribute("tabindex", "-1"));
  }, [c, g]);
  const ie = (h) => {
    const C = rt({
      isInitialActiveChild: h,
      monthChangeDirection: s,
      activeDate: o,
      parent: l.current
    }), _ = N(C.year);
    return { month: y(C.month), year: _ };
  }, Q = e && x(e, {
    ...o,
    month: o.month + 1,
    day: 1
  }) || o.year === $ && o.month === 12, se = t && (x({ ...o, day: 1 }, t) || ee(t, { ...o, day: 1 })) || o.year === I && o.month === 1, G = (h) => {
    Array.from(
      l.current.children
    ).some((_) => _.classList.contains("-shownAnimated")) || n(h);
  }, te = () => {
    g || p();
  }, D = () => {
    c || f();
  };
  re(() => {
    if (c) {
      const C = document.querySelector(
        ".Calendar__monthSelectorItem.-active"
      ).querySelector("button");
      C && setTimeout(() => {
        C.focus();
      }, 100);
    }
    if (g) {
      const C = document.querySelector(
        ".Calendar__yearSelectorItem.-active"
      )?.querySelector("button");
      C && setTimeout(() => {
        C.focus();
      }, 100);
    }
  }, [c, g]);
  const O = (h) => {
    (h.key === "Enter" || h.key === " ") && (h.preventDefault(), te());
  }, L = (h) => {
    (h.key === "Enter" || h.key === " ") && (h.preventDefault(), D());
  }, le = [!0, !1].map((h) => {
    const { month: C, year: _ } = ie(h), Y = C === y(o.month), ce = {
      ...Y ? {} : { "aria-hidden": !0 }
    };
    return /* @__PURE__ */ me(
      Nt,
      {
        onAnimationEnd: Fe,
        className: `Calendar__monthYear ${h ? "-shown" : "-hiddenNext"}`,
        role: "presentation",
        ...ce,
        children: [
          /* @__PURE__ */ i(
            Lt,
            {
              onClick: () => {
                te();
              },
              type: "button",
              className: "Calendar__monthText",
              "aria-label": c ? "Month Selector " : `${C}, Click here to ${R}`,
              tabIndex: Y ? 0 : -1,
              "aria-expanded": c ? "true" : "false",
              onKeyDown: O,
              ...ce,
              children: C
            }
          ),
          /* @__PURE__ */ i(
            Yt,
            {
              onClick: () => {
                D();
              },
              type: "button",
              className: "Calendar__yearText",
              "aria-label": g ? "Year Selector" : `${_}, Click here to ${ae}`,
              tabIndex: Y ? 0 : -1,
              "aria-expanded": g ? "true" : "false",
              onKeyDown: L,
              ...ce,
              children: _
            }
          )
        ]
      },
      String(h)
    );
  });
  return /* @__PURE__ */ me(At, { ref: F, className: "Calendar__header", children: [
    /* @__PURE__ */ i(
      qe,
      {
        className: "Calendar__monthArrowWrapper -right",
        onClick: () => {
          G("PREVIOUS");
        },
        "aria-label": P,
        type: "button",
        disabled: se,
        $isMonthSelectorOpen: c,
        $isYearSelectorOpen: g,
        children: /* @__PURE__ */ i(Ge, { className: "Calendar__monthArrow" })
      }
    ),
    /* @__PURE__ */ me(
      Pt,
      {
        className: "Calendar__monthYearContainer",
        ref: l,
        "data-testid": "month-year-container",
        children: [
          " ",
          le
        ]
      }
    ),
    /* @__PURE__ */ i(
      qe,
      {
        className: "Calendar__monthArrowWrapper -left",
        onClick: () => {
          c ? p() : g ? f() : G("NEXT");
        },
        "aria-label": c || g ? "Clear Button" : a,
        type: "button",
        disabled: Q,
        $isMonthSelectorOpen: c,
        $isYearSelectorOpen: g,
        children: /* @__PURE__ */ i(Ge, { className: "Calendar__monthArrow" })
      }
    )
  ] });
}, He = (e, t) => e ? e.children[t] : null, Pe = (e) => e && (e.hasAttribute("aria-hidden") ? null : e), Ne = (e, t) => {
  e.preventDefault(), t && (t.setAttribute("tabindex", "0"), t.focus());
}, Ze = (e, t) => He(
  t,
  Array.from(e.parentElement.children).indexOf(e)
), ze = (e, { allowVerticalArrows: t }) => {
  const { activeElement: n } = document, { nextSibling: o, previousSibling: s } = n.parentElement, p = Pe(
    n.nextSibling || He(o, 0)
  ), f = s ? s.children.length - 1 : 0, c = Pe(
    n.previousSibling || He(s, f)
  ), g = Pe(
    Ze(n, o)
  ), v = Pe(
    Ze(n, s)
  );
  switch (n.dataset.isDefaultSelectable === "true" || (n.tabIndex = "-1"), e.key) {
    case "ArrowRight":
      Ne(e, p);
      break;
    case "ArrowLeft":
      Ne(e, c);
      break;
    case "ArrowDown":
      t && Ne(e, g);
      break;
    case "ArrowUp":
      t && Ne(e, v);
      break;
  }
}, It = b.div`
  position: absolute;
  width: 100%;
  height: 84%;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media ${fe.mobile} {
    height: 84%;
  }

  &.-open {
    z-index: 10;
    border-top: ${K["1x"]} solid
      ${(e) => e.theme.components.datePicker.borderColorCalendar};
  }
`, Rt = b.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`, Bt = b.ul`
  align-content: center;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  border-radius: 0 0 ${A["3x"]} ${A["3x"]};
  z-index: 2;
  background-color: ${(e) => e.theme.components.datePicker.backgroundColorCalendar};
  transform: translateY(-150%);
  will-change: transform;
  transition: transform 0.6s;
  height: 100%;
  padding: 0 ${k["4x"]};
  gap: ${k["1x"]};

  @media ${fe.mobile} {
    padding: 0 ${k["2x"]};
  }

  &.-open {
    transform: translateY(0);
  }
`, Ft = b.li`
  width: calc(25% - 3px);
  display: flex;
  justify-content: center;
  border-radius: ${A["1x"]};
  border-width: ${K["1x"]};

  &:not(.-active) .Calendar__monthSelectorItemText:not(:disabled):hover,
  &:not(.-active) .Calendar__monthSelectorItemText:not(:disabled):focus {
    border-radius: ${A["1x"]};
    border: ${K["1x"]} solid
      ${(e) => e.theme.components.datePicker.borderColorDayHover};
  }

  &.-active .Calendar__monthSelectorItemText {
    background-color: ${(e) => e.theme.components.datePicker.fillDaySelected};
    color: ${(e) => e.theme.components.datePicker.textColorDaySelected};
    &:focus-visible {
      outline: 2px solid
        ${(e) => e.theme.components.datePicker.borderColorDayHover} !important;
      outline-offset: 2px;
    }
  }
`, Ht = b.button`
  border: none;
  height: 40px;
  width: 73px;
  font-size: ${pe.xsmall};
  font-family: ${be.inter}, 'Medium';
  cursor: pointer;
  background: none;
  border-radius: ${A["1x"]};
  color: ${(e) => e.theme.components.datePicker.textColorDay};
  transition: opacity 0.3s, transform 0.3s;

  &:focus {
    background: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`, zt = ({
  activeDate: e,
  maximumDate: t,
  minimumDate: n,
  onMonthSelect: o,
  isOpen: s,
  locale: p
}) => {
  const f = J(null), c = J(null);
  re(() => {
    const l = s ? "add" : "remove";
    c.current.classList[l]("-open"), f.current.classList[l]("-open");
  }, [s]);
  const { getMonthNumber: g, isBeforeDate: v } = Se(p), { months: I } = ke(p);
  return /* @__PURE__ */ i(
    It,
    {
      role: "presentation",
      ref: c,
      className: "Calendar__monthSelectorAnimationWrapper",
      ...s ? {} : { "aria-hidden": !0 },
      children: /* @__PURE__ */ i(
        Rt,
        {
          role: "presentation",
          "data-testid": "month-selector-wrapper",
          className: "Calendar__monthSelectorWrapper",
          onKeyDown: (l) => {
            ze(l, { allowVerticalArrows: !0 });
          },
          children: /* @__PURE__ */ i(
            Bt,
            {
              ref: f,
              className: "Calendar__monthSelector",
              "data-testid": "month-selector",
              children: (() => I.map((l) => {
                const y = g(l), x = { day: 1, month: y, year: e.year }, N = t && v(t, { ...x, month: y }), z = n && (v({ ...x, month: y + 1 }, n) || ee({ ...x, month: y + 1 }, n)), a = y === e.month;
                return /* @__PURE__ */ i(
                  Ft,
                  {
                    className: `Calendar__monthSelectorItem ${a ? "-active" : ""}`,
                    children: /* @__PURE__ */ i(
                      Ht,
                      {
                        tabIndex: a && s ? 0 : -1,
                        onClick: () => {
                          o(y);
                        },
                        className: "Calendar__monthSelectorItemText",
                        type: "button",
                        disabled: N || z,
                        "aria-pressed": a,
                        "data-is-default-selectable": a,
                        children: l.substring(0, 3)
                      }
                    )
                  },
                  l
                );
              }))()
            }
          )
        }
      )
    }
  );
}, Ut = b.div`
  position: absolute;
  width: 100%;
  height: 84%;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media ${fe.mobile} {
    height: 84%;
  }
  border-radius: 0 0 ${A["3x"]} ${A["3x"]};

  &.-open {
    z-index: 10;
    border-top: ${K["1x"]} solid
      ${(e) => e.theme.components.datePicker.borderColorCalendar};
  }
`, Vt = b.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`, Ot = b.ul`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
  gap: ${k["1x"]};
  background-color: ${(e) => e.theme.components.datePicker.backgroundColorCalendar};
  transform: translateY(-150%);
  will-change: transform;
  transition: transform 0.6s;
  height: 100%;

  align-content: flex-start;
  scrollbar-width: none;
  overflow: scroll;
  position: relative;
  width: 100%;
  padding: 0 ${k["4x"]};
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${fe.mobile} {
    padding: 0 ${k["2x"]};
  }

  &.-open {
    transform: translateY(0);
  }
`, Xt = b.li`
  width: calc(25% - 3px);
  display: flex;
  justify-content: center;

  &:not(.-active) .Calendar__yearSelectorText:not(:disabled):hover,
  &:not(.-active) .Calendar__yearSelectorText:not(:disabled):focus {
    border-radius: ${A["1x"]};
    border: ${K["1x"]} solid
      ${(e) => e.theme.components.datePicker.borderColorDayHover};
  }

  &.-active .Calendar__yearSelectorText {
    background-color: ${(e) => e.theme.components.datePicker.fillDaySelected};
    color: ${(e) => e.theme.components.datePicker.textColorDaySelected};
    &:focus-visible {
      outline: 2px solid
        ${(e) => e.theme.components.datePicker.borderColorDayHover} !important;
      outline-offset: 2px;
    }
  }
`, Kt = b.button`
  border: none;
  height: 40px;
  width: 73px;
  font-size: ${pe.xsmall};
  font-family: ${be.inter}, 'Medium';
  cursor: pointer;
  background: none;
  border-radius: ${A["1x"]};
  color: ${(e) => e.theme.components.datePicker.textColorDay};
  transition: opacity 0.3s, transform 0.3s;

  &:focus {
    background: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`, st = ({
  isOpen: e,
  activeDate: t,
  onYearSelect: n,
  selectorStartingYear: o,
  selectorEndingYear: s,
  maximumDate: p,
  minimumDate: f,
  locale: c
}) => {
  const g = J(null), v = J(null), I = J(null), { getLanguageDigits: $, getToday: F } = Se(c), l = o || F().year - Ct, y = s || F().year + Dt, x = [];
  for (let a = l; a <= y; a += 1)
    x.push(a);
  return re(() => {
    const a = e ? "add" : "remove", P = g.current.querySelector(
      ".Calendar__yearSelectorItem.-active"
    );
    P || console.log(
      "Provided value for year is out of selectable year range. You're probably using a wrong locale prop value or your provided value's locale is different from the date picker locale. Try changing the 'locale' prop or the value you've provided."
    ), I.current.classList[a]("-open"), g.current.classList[a]("-faded"), P && (v.current.scrollTop = P.offsetTop - P.offsetHeight * 5), v.current.classList[a]("-open");
  }, [e]), /* @__PURE__ */ i(
    Ut,
    {
      className: "Calendar__yearSelectorAnimationWrapper",
      ref: I,
      role: "presentation",
      ...e ? {} : { "aria-hidden": !0 },
      children: /* @__PURE__ */ i(
        Vt,
        {
          ref: g,
          className: "Calendar__yearSelectorWrapper",
          role: "presentation",
          "data-testid": "year-selector-wrapper",
          onKeyDown: (a) => {
            ze(a, { allowVerticalArrows: !1 });
          },
          children: /* @__PURE__ */ i(
            Ot,
            {
              ref: v,
              className: "Calendar__yearSelector",
              "data-testid": "year-selector",
              children: (() => x.map((a) => {
                const P = p && a > p.year, R = f && a < f.year, U = t.year === a;
                return /* @__PURE__ */ i(
                  Xt,
                  {
                    className: `Calendar__yearSelectorItem ${U ? "-active" : ""}`,
                    children: /* @__PURE__ */ i(
                      Kt,
                      {
                        tabIndex: U && e ? 0 : -1,
                        className: "Calendar__yearSelectorText",
                        type: "button",
                        onClick: () => {
                          n(a);
                        },
                        disabled: P || R,
                        "aria-pressed": U,
                        "data-is-default-selectable": U,
                        children: $(a)
                      }
                    )
                  },
                  a
                );
              }))()
            }
          )
        }
      )
    }
  );
};
st.defaultProps = {
  selectorStartingYear: 0,
  selectorEndingYear: 0
};
const jt = b.div`
  position: relative;
  overflow: hidden;
  min-height: 260px;
`, Je = b.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  gap: ${k["1x"]};
  width: 100%;
  will-change: transform, opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
  transition: var(--animation-duration);

  &.-hiddenPrevious {
    opacity: 0.5;
    transform: translateX(-100%);
  }

  &.-hiddenNext {
    opacity: 0.5;
    transform: translateX(100%);
  }

  &.-shown {
    opacity: 1;
    transform: translateX(0);
  }

  &.-shownAnimated {
    animation: var(--animation-duration) FadeContentToCenter forwards;
  }
`, qt = b.div`
  min-width: 40px;
  height: 40px;
  text-align: center;
  padding: 0;
  margin: 0;
  transition: background 0.2s, transform 0.2s, opacity 0.2s;
  border: 1px solid transparent;
  color: ${(e) => e.theme.components.datePicker.textColorDay};
  font-family: ${be.inter}, 'Regular';
  font-size: ${ge.regular.S.fontSize};
  font-weight: ${ge.regular.S.fontWeight};
  line-height: ${ge.regular.S.lineHeight};
  border-radius: ${A["1x"]};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  // &.-ltr {
  //   min-height: 2.6em;
  //   font-size: 11px;
  // }

  // &.-rtl {
  //   font-size: 1.55em;
  //   height: 2.45em;
  // }

  &:not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(
      .-selectedBetween
    ):not(.-selected)&:focus {
    border-radius: ${A["1x"]};
    border-color: ${(e) => e.theme.components.datePicker.borderColorDayHover};
    border-width: ${K["1x"]};
  }

  &:not(.-blank):not(.-selectedStart):not(.-selectedEnd):not(
      .-selectedBetween
    ):not(.-selected):not(.-disabled)&:hover {
    border-radius: ${A["1x"]};
    border-color: ${(e) => e.theme.components.datePicker.borderColorDayHover};
    border-width: ${K["1x"]};
  }

  &.-selected,
  &.-selectedStart,
  &.-selectedEnd {
    color: ${(e) => e.theme.components.datePicker.textColorDaySelected};
  }

  &.-ltr.-selectedStart {
    border-radius: 100em 0 0 100em;
  }

  &.-rtl.-selectedStart {
    border-radius: 0 100em 100em 0;
  }

  &.-selectedBetween {
    background-color: ${(e) => e.theme.components.datePicker.fillDaySelected};
    border-radius: 0;
  }

  &.-ltr.-selectedEnd {
    border-top-right-radius: 100em;
    border-bottom-right-radius: 100em;
  }

  &.-rtl.-selectedEnd {
    border-top-left-radius: 100em;
    border-bottom-left-radius: 100em;
  }

  &.-weekend:not(.-selected):not(.-blank):not(.-selectedStart):not(
      .-selectedEnd
    ):not(.-selectedBetween) {
    color: ${(e) => e.theme.components.datePicker.textColorDayWeekend};
  }

  &.-weekend.-today:not(.-selectedStart):not(.-selectedEnd):not(
      .-selectedBetween
    )::after {
    background: ${(e) => e.theme.components.datePicker.textColorDayWeekend};
  }

  &.-outofmonth:not(.-selected):not(.-blank):not(.-selectedStart):not(
      .-selectedEnd
    ):not(.-selectedBetween) {
    color: ${(e) => e.theme.components.datePicker.textColorDayWeekend};
  }

  &.-outofmonth.-today:not(.-selectedStart):not(.-selectedEnd):not(
      .-selectedBetween
    )::after {
    background: ${(e) => e.theme.components.datePicker.textColorDayWeekend};
  }

  &.-disabled {
    cursor: not-allowed;
    pointer-events: all !important;
    background-color: ${(e) => e.theme.components.datePicker.backgroundDayDisabled};
    border-radius: ${A["1x"]};
    color: ${(e) => e.theme.components.datePicker.textColorDayDisabled} !important;
    border-color: transparent;
  }
  &.-selected {
    border-radius: ${A["1x"]};
    border-width: ${K["1x"]};
    background-color: ${(e) => e.theme.components.datePicker.fillDaySelected};
  }
  &.-today:not(.-selectedStart):not(.-selectedEnd):not(.-selectedBetween) {
    border-radius: ${A["1x"]};
    position: relative;
    border-width: ${K["1x"]};
    &::after {
      content: '•';
      content: '•' / '';
      position: absolute;
      background: transparent !important;
      top: 22px;
      font-size: ${pe.xxsmall};
      opacity: 1 !important;
    }
  }

  &.-today:hover:not(.-selectedStart):not(.-selectedEnd):not(
      .-selectedBetween
    )::after {
    opacity: 0;
  }

  &.-blank {
    color: transparent;
    cursor: default;
    pointer-events: none;
  }
`, Gt = b.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  &:last-of-type {
    justify-content: flex-start;

    .Calendar__day {
      margin-right: 3.5px;

      @media ${fe.mobile} {
        margin-right: 0;
      }
    }
  }
`, it = ({
  activeDate: e,
  value: t,
  monthChangeDirection: n,
  onSlideChange: o,
  disabledDays: s,
  onDisabledDayError: p,
  minimumDate: f,
  maximumDate: c,
  onChange: g,
  locale: v,
  calendarTodayClassName: I,
  calendarSelectedDayClassName: $,
  calendarRangeStartClassName: F,
  calendarRangeEndClassName: l,
  calendarRangeBetweenClassName: y,
  shouldHighlightWeekends: x,
  isQuickSelectorOpen: N,
  customDaysClassName: z,
  includeOutOfMonthDays: a,
  selectorStartingYear: P,
  selectorEndingYear: R,
  allowedDates: U,
  weekendDisabled: ae
}) => {
  const q = J(null), { isRtl: ie, weekDays: Q } = ke(v), {
    getToday: se,
    isBeforeDate: G,
    checkDayInDayRange: te,
    getMonthFirstWeekday: D,
    getMonthLength: O,
    getLanguageDigits: L,
    getMonthName: le
  } = Se(v), h = se();
  re(() => {
    n && at({
      direction: n,
      parent: q.current
    });
  }, [n]);
  const C = (r) => {
    const w = St(t), d = w.from && w.to ? { from: null, to: null } : w, T = d.from ? "to" : "from";
    d[T] = r;
    const { from: m, to: H } = d;
    G(d.to, d.from) && (d.from = H, d.to = m);
    const B = (de) => te({
      day: de,
      from: d.from,
      to: d.to
    }), E = s.find(B);
    return E ? (p(E), t) : d;
  }, _ = (r) => {
    const w = t.some(
      (m) => ee(m, r)
    ), d = [...t, r], T = t.filter(
      (m) => !ee(m, r)
    );
    return w ? T : d;
  }, Y = (r) => {
    const d = (() => {
      switch (ye(t)) {
        case ue:
          return r;
        case De:
          return C(r);
        case Ce:
          return _(r);
      }
    })();
    g(d);
  }, ce = (r) => {
    const w = ye(t);
    if (w === ue)
      return ee(r, t);
    if (w === Ce)
      return t.some(
        (d) => ee(d, r)
      );
  }, u = (r) => {
    const w = ee(r, h), d = ce(r), { from: T, to: m } = t || {}, H = ee(r, T), B = ee(r, m), E = te({
      day: r,
      from: T,
      to: m
    });
    return {
      isToday: w,
      isSelected: d,
      isStartingDayRange: H,
      isEndingDayRange: B,
      isWithinRange: E
    };
  }, W = (r) => {
    const {
      isToday: w,
      isSelected: d,
      isStartingDayRange: T,
      isEndingDayRange: m,
      isWithinRange: H
    } = u(r), B = z?.find(
      (de) => ee(r, de)
    );
    return "".concat(w && !d ? ` -today ${I}` : "").concat(r.isStandard ? "" : " -blank").concat(r.isWeekend && x ? " -weekend" : "").concat(r.outOfMonth ? " -outofmonth" : "").concat(
      B ? ` ${B.className}` : ""
    ).concat(d ? ` -selected ${$}` : "").concat(
      T ? ` -selectedStart ${F}` : ""
    ).concat(
      m ? ` -selectedEnd ${l}` : ""
    ).concat(
      H ? ` -selectedBetween ${y}` : ""
    ).concat(r.isDisabled ? " -disabled" : "");
  }, j = (r) => {
    const w = Ae(
      D(r),
      "starting-blank"
    ), d = Ae(O(r), void 0).map(
      (m) => ({
        ...m,
        isStandard: !0,
        month: r.month,
        year: r.year
      })
    );
    if (a) {
      const m = {
        ...r,
        month: r.month - 1
      };
      m.month < 1 && (m.month = 12, m.year -= 1);
      const H = D(r) === 0 ? [] : Ae(O(m), void 0).map((S) => ({
        ...S,
        outOfMonth: !0,
        isStandard: !0,
        month: m.month,
        year: m.year
      })).slice(-D(r)), B = {
        ...r,
        month: r.month + 1
      };
      B.month > 12 && (B.month = 1, B.year += 1);
      const E = Ae(
        O(B),
        void 0
      ).map((S) => ({
        ...S,
        outOfMonth: !0,
        isStandard: !0,
        month: B.month,
        year: B.year
      })).slice(0, 42 - (H.length + d.length));
      return [...H, ...d, ...E];
    }
    return [...w, ...d];
  }, V = ({ isDisabled: r, ...w }) => {
    r ? p(w) : Y(w);
  }, X = ({
    isOnActiveSlide: r,
    isStandard: w,
    isSelected: d,
    isStartingDayRange: T,
    isToday: m,
    day: H
  }) => {
    if (N || !r || !w)
      return !1;
    if (d || T || m || H === 1)
      return !0;
  }, M = ({ id: r, value: w, month: d, year: T, isStandard: m, outOfMonth: H }, B) => {
    const E = { day: w, month: d, year: T };
    let de = !1;
    U && U.some((oe) => ee(E, oe)) && (de = !0);
    const S = s.some(
      (oe) => ee(E, oe)
    ), Z = G(E, f), Ye = G(c, E), We = T < P || T > R, ve = m && (Z || Ye || We), $e = Q.some(
      (oe, Re) => oe.isWeekend && Re === B
    ), he = U ? !de : S || ve || $e && ae, _e = W({
      ...E,
      isWeekend: $e,
      isStandard: m,
      isDisabled: he,
      outOfMonth: H
    }), Ee = `${Q[B].name}, ${w} ${le(
      d
    )} ${T}`, Me = d === e.month, Te = u(E), { isSelected: Ie, isStartingDayRange: Ve, isEndingDayRange: Oe, isWithinRange: lt } = Te, Xe = X({
      ...E,
      ...Te,
      isOnActiveSlide: Me,
      isStandard: m
    }), ct = () => {
      const oe = new Date(Ee), Re = oe.getFullYear(), dt = oe.getMonth() + 1, mt = oe.getDate();
      return h.year === Re && h.month === dt && h.day === mt;
    };
    return /* @__PURE__ */ me(
      qt,
      {
        tabIndex: Xe ? 0 : -1,
        className: `Calendar__day -${ie ? "rtl" : "ltr"} ${_e}`,
        onClick: () => {
          V({ ...E, isDisabled: he });
        },
        onKeyDown: ({ key: oe }) => {
          oe === "Enter" && V({ ...E, isDisabled: he });
        },
        "aria-disabled": he,
        ...ct() && { "aria-current": "date" },
        "aria-selected": Ie || Ve || Oe || lt,
        ...!m || !Me || N ? { "aria-hidden": !0 } : {},
        role: "gridcell",
        "data-is-default-selectable": Xe,
        children: [
          /* @__PURE__ */ i("span", { "aria-hidden": "true", children: m ? L(w) : "" }),
          /* @__PURE__ */ i(ft, { children: Ee })
        ]
      },
      r
    );
  }, ne = (r) => {
    const w = rt({
      activeDate: e,
      isInitialActiveChild: r,
      monthChangeDirection: n,
      parent: q.current
    }), d = j(w), T = (m) => {
      const H = d.slice(m * 7, m * 7 + 7).map(M);
      return H.length > 0 ? /* @__PURE__ */ i(
        Gt,
        {
          className: "Calendar__weekRow",
          role: "row",
          children: H
        },
        String(m)
      ) : "";
    };
    return Array.from(Array(6).keys()).map(T);
  };
  return /* @__PURE__ */ me(
    jt,
    {
      ref: q,
      className: "Calendar__sectionWrapper",
      role: "presentation",
      "data-testid": "days-section-wrapper",
      onKeyDown: (r) => {
        ze(r, { allowVerticalArrows: !0 });
      },
      children: [
        /* @__PURE__ */ i(
          Je,
          {
            onAnimationEnd: (r) => {
              Fe(r), o();
            },
            className: "Calendar__section -shown",
            role: "rowgroup",
            children: ne(!0)
          }
        ),
        /* @__PURE__ */ i(
          Je,
          {
            onAnimationEnd: (r) => {
              Fe(r), o();
            },
            className: "Calendar__section -hiddenNext",
            role: "rowgroup",
            children: ne(!1)
          }
        )
      ]
    }
  );
};
it.defaultProps = {
  onChange: () => {
  },
  onDisabledDayError: () => {
  },
  disabledDays: [],
  calendarTodayClassName: "",
  calendarSelectedDayClassName: "",
  calendarRangeStartClassName: "",
  calendarRangeBetweenClassName: "",
  calendarRangeEndClassName: "",
  shouldHighlightWeekends: !1
};
const Zt = b.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  * {
    margin: 0;
    box-sizing: border-box;
    direction: ltr;
  }

  direction: rtl;

  &.-rtl * {
    direction: rtl;
  }

  --animation-duration: 0.4s;

  font-size: 11px;
  background: ${(e) => e.theme.components.datePicker.backgroundColorCalendar};
  box-shadow: 0 1em 4em rgba(0, 0, 0, 0.07);
  border: ${K["1x"]} solid
    ${(e) => e.theme.components.datePicker.borderColorCalendar};
  border-radius: ${A["3x"]};
  position: relative;
  user-select: none;
  display: flex;
  flex-direction: column;
  z-index: 10;
  padding: ${k["2x"]};
  width: 320px;
  gap: ${k["2x"]};

  @media ${fe.mobile} {
    padding: ${k["2x"]};
    width: 298px;
  }

  &.-rtl .Calendar__section.-hiddenPrevious {
    transform: translateX(100%);
  }

  &.-rtl .Calendar__section.-hiddenNext {
    transform: translateX(-100%);
  }

  &.-noFocusOutline *:focus {
    outline: none !important;
  }

  &.-rtl .Calendar__monthArrowWrapper.-left {
    transform: rotate(-90deg);
  }

  &.-rtl .Calendar__monthArrowWrapper.-right {
    transform: rotate(90deg);
  }

  &.-rtl .Calendar__monthYear.-hiddenNext {
    transform: translateX(-150%);
  }

  &.-rtl .Calendar__monthYear.-hiddenPrevious {
    transform: translateX(50%);
  }

  &:not(.-noFocusOutline) .Calendar__monthYear.-shown > *:focus {
    outline: 1px dashed rgba(0, 0, 0, 0.4);
    outline-offset: 2px;
  }

  &.-rtl .Calendar__monthText:hover {
    transform: translateX(0.2em) scale(0.95);
  }

  &.-rtl .Calendar__yearText:hover {
    transform: translateX(-0.2em) scale(0.95);
  }

  &.-rtl .Calendar__monthYear .Calendar__yearText.-hidden {
    transform: translateX(-50%);
  }

  &.-rtl .Calendar__monthYear .Calendar__monthText.-hidden {
    transform: translateX(50%);
  }
`, Jt = b.div`
  display: flex;
  justify-content: space-between;
  color: ${(e) => e.theme.components.datePicker.textColorWeekdays};
  font-weight: ${ge.regular.S.fontWeight};
  font-size: ${pe.xsmall};
  font-family: ${be.inter};
  padding: 0;
  position: relative;
`, Qt = b.abbr`
  min-width: 40px;
  height: 20px;
  display: block;
  padding: 2px;
  text-align: center;
  text-decoration: none;
`, en = (e, t) => {
  const n = new Date(e.year, e.month - 1, e.day), o = new Date(t.year, t.month - 1, t.day), s = [];
  for (; n <= o; )
    s.push({
      year: n.getFullYear(),
      month: n.getMonth() + 1,
      day: n.getDate()
    }), n.setDate(n.getDate() + 1);
  return s;
}, Qe = (e) => {
  if (!e)
    return null;
  const t = [];
  return e.forEach((n) => {
    "from" in n && "to" in n ? t.push(...en(n.from, n.to)) : t.push(n);
  }), t;
}, tn = ({
  value: e,
  onChange: t,
  onDisabledDayError: n,
  calendarClassName: o,
  calendarTodayClassName: s,
  calendarSelectedDayClassName: p,
  disabledDays: f,
  minimumDate: c,
  maximumDate: g,
  selectorStartingYear: v,
  selectorEndingYear: I,
  locale: $,
  shouldHighlightWeekends: F,
  customDaysClassName: l,
  includeOutOfMonthDays: y,
  allowedDates: x,
  weekendDisabled: N
}) => {
  const z = J(null), [a, P] = Le({
    activeDate: {},
    monthChangeDirection: "",
    isMonthSelectorOpen: !1,
    isYearSelectorOpen: !1
  }), [R, U] = Le(), ae = (u) => {
    const W = Qe(u), j = [];
    W?.forEach(
      (M) => j.push(new Date(M.year, M.month - 1, M.day).getTime())
    );
    const V = new Date(Math.min(...j)), X = new Date(Math.max(...j));
    U({
      minDate: {
        year: V.getFullYear(),
        month: V.getMonth() + 1,
        day: V.getDate()
      },
      maxDate: {
        year: X.getFullYear(),
        month: X.getMonth() + 1,
        day: X.getDate()
      }
    });
  };
  re(() => {
    x ? ae(x) : U({
      minDate: c,
      maxDate: g
    });
  }, [c, g, x]), re(() => {
    const u = (W) => {
      W.key === "Tab" && z.current.classList.remove("-noFocusOutline");
    };
    return z.current?.addEventListener(
      "keyup",
      () => u,
      !1
    ), () => {
      z.current?.removeEventListener(
        "keyup",
        () => u,
        !1
      );
    };
  });
  const { getToday: q } = Se($), { weekDays: ie, isRtl: Q } = ke($), se = q(), G = (u) => () => {
    P({
      ...a,
      [u]: !a[u]
    });
  }, te = G("isMonthSelectorOpen"), D = G("isYearSelectorOpen"), O = () => {
    const u = ye(e);
    return u === Ce && e.length ? xe(e[0]) : u === ue && e ? xe(e) : u === De && e.from ? xe(e.from) : xe(se);
  }, L = Object.keys(a.activeDate).length > 0 ? xe(a.activeDate) : O(), le = ie.map((u) => /* @__PURE__ */ i(
    Qt,
    {
      title: u.name,
      className: "Calendar__weekDay",
      children: u.short
    },
    u.name
  )), h = (u) => {
    P({
      ...a,
      monthChangeDirection: u
    });
  }, C = () => {
    P({
      ...a,
      activeDate: Be(
        L,
        a.monthChangeDirection
      ),
      monthChangeDirection: ""
    });
  }, _ = (u) => {
    const W = document.querySelector(u);
    W && setTimeout(() => {
      W.focus();
    }, 100);
  }, Y = (u) => {
    P({
      ...a,
      activeDate: { ...L, month: u },
      isMonthSelectorOpen: !1
    }), _(".Calendar__monthText");
  }, ce = (u) => {
    P({
      ...a,
      activeDate: { ...L, year: u },
      isYearSelectorOpen: !1
    }), _(".Calendar__yearText");
  };
  return /* @__PURE__ */ me(
    Zt,
    {
      className: `Calendar -noFocusOutline ${o} -${Q ? "rtl" : "ltr"}`,
      role: "grid",
      ref: z,
      children: [
        /* @__PURE__ */ i(
          Wt,
          {
            maximumDate: R?.maxDate,
            minimumDate: R?.minDate,
            activeDate: L,
            onMonthChange: h,
            onMonthSelect: te,
            onYearSelect: D,
            monthChangeDirection: a.monthChangeDirection,
            isMonthSelectorOpen: a.isMonthSelectorOpen,
            isYearSelectorOpen: a.isYearSelectorOpen,
            locale: $,
            selectorStartingYear: v,
            selectorEndingYear: I
          }
        ),
        /* @__PURE__ */ i(
          zt,
          {
            isOpen: a.isMonthSelectorOpen,
            activeDate: L,
            onMonthSelect: Y,
            maximumDate: R?.maxDate,
            minimumDate: R?.minDate,
            locale: $
          }
        ),
        /* @__PURE__ */ i(
          st,
          {
            isOpen: a.isYearSelectorOpen,
            activeDate: L,
            onYearSelect: ce,
            selectorStartingYear: v,
            selectorEndingYear: I,
            maximumDate: R?.maxDate,
            minimumDate: R?.minDate,
            locale: $
          }
        ),
        /* @__PURE__ */ i(Jt, { className: "Calendar__weekDays", children: le }),
        /* @__PURE__ */ i(
          it,
          {
            activeDate: L,
            value: e,
            selectorStartingYear: v,
            selectorEndingYear: I,
            monthChangeDirection: a.monthChangeDirection,
            onSlideChange: C,
            disabledDays: f,
            onDisabledDayError: n,
            minimumDate: R?.minDate,
            maximumDate: R?.maxDate,
            onChange: t,
            calendarTodayClassName: s,
            calendarSelectedDayClassName: p,
            locale: $,
            shouldHighlightWeekends: F,
            customDaysClassName: l,
            includeOutOfMonthDays: y,
            isQuickSelectorOpen: a.isYearSelectorOpen || a.isMonthSelectorOpen,
            allowedDates: Qe(x),
            weekendDisabled: N
          }
        )
      ]
    }
  );
}, nn = b.div`
  ${({ $textSize: e }) => e === "small" ? `
        --svg-wrapper-width-global: ${k["4x"]};
        --svg-wrapper-height-global: ${k["4x"]};
      ` : `
        --svg-wrapper-width-global: 18px;
        --svg-wrapper-height-global: 18px;
      `}

  && input::placeholder {
    color: ${({ $isDisabled: e, theme: t }) => e ? t.components.datePicker.placeHolderDisabledColor : t.components.datePicker.placeHolderColor};
  }
  && div[textsize] svg {
    color: ${({ $isDisabled: e, theme: t }) => e ? t.components.datePicker.iconDisabledColor : t.components.datePicker.iconColor};
  }
`, on = b.div`
  display: flex;
  align-items: center;
  & > svg {
    color: ${({ theme: e }) => e.components.search.iconColor};
  }
  &:focus {
    border-radius: ${A["1x"]};
    border: ${K["1x"]} solid
      ${(e) => e.theme.components.datePicker.borderColorDayHover};
  }
`, rn = tt(
  ({
    value: e,
    onChange: t,
    inputId: n,
    isDisabled: o = !1,
    inputPlaceholder: s,
    dateFormatOptions: p,
    inputClassName: f,
    inputName: c,
    formatInputText: g,
    locale: v,
    hasError: I,
    message: $,
    showErrorIcon: F,
    isRequired: l,
    textSize: y,
    labelProp: x,
    infoProp: N,
    trailingText: z,
    ...a
  }, P) => {
    const {
      from: R,
      to: U,
      defaultPlaceholder: ae,
      defaultLabel: q
    } = ke(v), ie = (D) => {
      if (!D)
        return "";
      const O = new Date(D.year, D.month - 1, D.day), L = p || {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      };
      return O.toLocaleDateString(v, L)?.replace(new RegExp("/", "g"), " / ");
    }, Q = (D) => {
      if (!D.from || !D.to)
        return "";
      const { from: O, to: L } = D, le = new Date(O.year, O.month - 1, O.day), h = new Intl.DateTimeFormat("en-US").format(le).toString(), C = new Date(L.year, L.month - 1, L.day), _ = new Intl.DateTimeFormat("en-US").format(C).toString();
      return `${R} ${h} ${U} ${_}`;
    }, se = () => {
      if (g)
        return g();
      switch (ye(e)) {
        case ue:
          return ie(e);
        case De:
          return Q(e);
      }
    }, G = s || ae;
    return x?.label, (() => /* @__PURE__ */ i(nn, { $textSize: y || "medium", $isDisabled: o, children: /* @__PURE__ */ i(
      gt,
      {
        startAdornmentProp: {
          startAdornment: /* @__PURE__ */ i(wt, { "aria-hidden": "true" })
        },
        endAdornmentProp: {
          endAdornment: e && t ? /* @__PURE__ */ i(
            on,
            {
              onFocus: (D) => {
                D.stopPropagation(), D.preventDefault();
              },
              children: /* @__PURE__ */ i(
                yt,
                {
                  role: "button",
                  "aria-label": "Clear Button",
                  onClick: () => {
                    o || t(void 0);
                  },
                  style: {
                    cursor: "pointer",
                    height: k["4x"],
                    width: k["4x"],
                    zIndex: 1
                  },
                  tabIndex: o ? -1 : 0,
                  onKeyDown: (D) => {
                    (D.code === "Enter" || D.code === "Space") && t(void 0);
                  }
                }
              )
            }
          ) : void 0
        },
        "data-testid": "datepicker-input",
        readOnly: !0,
        ref: P,
        id: n,
        type: "text",
        value: se(),
        name: c,
        placeholder: G,
        disabled: o,
        className: f,
        isInvalid: I,
        helperText: $,
        showErrorIcon: F,
        isRequired: l,
        textSize: y,
        labelProp: {
          ...x,
          label: x?.label || q
        },
        infoProp: { ...N },
        trailingText: z,
        ...a
      }
    ) }))();
  }
), an = "CalendarInput", sn = b.div`
  background-color: rgba(0, 0, 0, 0);
  width: 100vw;
  height: 100vh;
  z-index: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
`, ln = b.div`
  position: relative;
  display: inline-block;
  padding-bottom: ${({ $hasHelper: e }) => e ? k["7x"] : "0"};
  min-width: ${({ $minWidth: e }) => e};
  @keyframes fadeCalendar {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeArrowFlipped {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
      transform: translateY(0) rotate(180deg);
    }
  }

  @keyframes fadeTextToCenter {
    to {
      opacity: 1;
      transform: translateX(-50%);
    }
  }

  @keyframes FadeContentToCenter {
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`, cn = b.div`
  position: ${({ $exceedOverflow: e }) => e ? "fixed" : "absolute"};
  top: calc(
    100%
      ${({ $hasHelper: e }) => e ? `- ${k["5x"]}` : `+ ${k["2x"]}`}
  );

  transform: translateY(2.5em);
  opacity: 1;
  animation: fadeCalendar 0.3s forwards;
  z-index: 2;

  &.-top {
    top: auto;
    bottom: calc(100% + -20px);
  }

  left: unset !important;
`, In = tt(
  ({
    value: e,
    isDisabled: t = !1,
    onChange: n,
    formatInputText: o,
    inputPlaceholder: s,
    inputClassName: p,
    inputName: f,
    wrapperClassName: c,
    calendarClassName: g,
    calendarTodayClassName: v,
    calendarSelectedDayClassName: I,
    calendarPopperPosition: $,
    disabledDays: F,
    onDisabledDayError: l,
    minimumDate: y,
    maximumDate: x,
    selectorStartingYear: N,
    selectorEndingYear: z,
    locale: a = "en-US",
    shouldHighlightWeekends: P,
    customDaysClassName: R,
    dateFormatOptions: U,
    isInvalid: ae,
    helperText: q,
    showErrorIcon: ie,
    isRequired: Q = !1,
    textSize: se,
    includeOutOfMonthDays: G = !0,
    onBlur: te,
    accessibilityOptions: D = {},
    labelProp: O,
    infoProp: L,
    trailingText: le,
    allowedDates: h,
    weekendDisabled: C = !1,
    exceedOverflow: _ = !1,
    inputRef: Y,
    ...ce
  }, u) => {
    const W = J(null), j = J(null), V = J(bt(an)), X = J(!1), [M, ne] = Le(!1), [Ue, r] = Le({}), { width: w, height: d } = xt();
    re(() => {
      const S = ye(e);
      if (S === Ce)
        return;
      (S === ue ? !M : !M && e.from && e.to) && (Y ?? j)?.current?.blur();
    }, [e, M]);
    const T = (S) => {
      if (S.persist(), !M)
        return;
      const Z = W.current.contains(
        S.relatedTarget
      );
      X.current ? (X.current = !1, (Y ?? j)?.current?.focus()) : Z && S.relatedTarget && S.relatedTarget.focus(), te && te(S);
    }, m = () => {
      !X.current && !t && ne(!0);
    };
    ut(() => {
      if (!M)
        return;
      const { left: S, width: Z, height: Ye, top: We } = W.current.getBoundingClientRect(), { clientWidth: ve, clientHeight: $e } = document.documentElement, he = S + Z > ve, _e = S < 0, Ee = We + Ye > $e, Me = () => {
        const Te = S + Z - ve;
        if (!he && !_e)
          return "";
        const Ie = Math.abs(S);
        return he ? `calc(50% - ${Te}px)` : `calc(50% + ${_e ? Ie : 0}px)`;
      };
      W.current.style.left = Me(), ($ === "auto" && Ee || $ === "top") && W?.current?.classList?.add("-top");
    }, [M]);
    const H = (S) => {
      const Z = ye(e);
      n && n(S), (Z === ue || Z === De) && ne(!1);
    }, B = (S) => {
      switch (S.key) {
        case "Enter":
          ne(!0);
          break;
        case "Escape":
          ne(!1), X.current = !0;
          break;
      }
    };
    re(() => {
      !M && X.current && ((Y ?? j)?.current?.focus(), X.current = !1);
    }, [X, M]);
    let E = "";
    switch (se) {
      case "small":
        E = "224px";
        break;
      case "large":
        E = "281px";
        break;
      case "medium":
      default:
        E = "252px";
    }
    const de = pt("input", {
      ariaDisabled: t,
      ariaInvalid: ae,
      ariaRequired: Q,
      ariaLabel: "MM / DD /YY",
      ...D
    });
    return re(() => {
      if (M && _) {
        const S = $ === "auto" || !$ ? "bottom" : $;
        r(
          je(
            Y ?? j,
            W,
            S,
            "datepicker"
          )
        );
        const Z = () => {
          r(
            je(
              Y ?? j,
              W,
              S,
              "datepicker"
            )
          );
        };
        return window.addEventListener("scroll", Z, !0), () => {
          window.removeEventListener("scroll", Z, !0);
        };
      }
    }, [M, _, w, d]), /* @__PURE__ */ me(
      ln,
      {
        onFocus: m,
        onBlur: T,
        onKeyUp: B,
        className: `DatePicker ${c}`,
        role: "presentation",
        $minWidth: E,
        $hasHelper: !!q && M,
        ref: u,
        children: [
          /* @__PURE__ */ i(
            rn,
            {
              ref: Y ?? j,
              isDisabled: t,
              formatInputText: o,
              value: e,
              onChange: n,
              inputPlaceholder: s,
              inputClassName: p,
              inputName: f,
              locale: a,
              dateFormatOptions: U,
              hasError: ae,
              message: M ? "" : q,
              inputId: V.current,
              showErrorIcon: !M && ie,
              isRequired: Q,
              textSize: se,
              ...de,
              labelProp: {
                showRequiredIndicator: Q,
                ...O
              },
              infoProp: { ...L },
              trailingText: le
            }
          ),
          M && !t && /* @__PURE__ */ me(ht, { children: [
            /* @__PURE__ */ i(
              sn,
              {
                "aria-hidden": !0,
                onClick: () => ne(!1)
              }
            ),
            /* @__PURE__ */ i(
              cn,
              {
                $exceedOverflow: _,
                ref: W,
                style: _ ? Ue : {},
                className: "DatePicker__calendarContainer",
                "data-testid": "calendar-container",
                role: "presentation",
                $hasHelper: !!q,
                children: /* @__PURE__ */ i(
                  tn,
                  {
                    value: e,
                    onChange: H,
                    calendarClassName: g,
                    calendarTodayClassName: v,
                    calendarSelectedDayClassName: I,
                    disabledDays: F,
                    onDisabledDayError: l,
                    minimumDate: y,
                    maximumDate: x,
                    selectorStartingYear: N,
                    selectorEndingYear: z,
                    locale: a,
                    shouldHighlightWeekends: P,
                    customDaysClassName: R,
                    includeOutOfMonthDays: G,
                    allowedDates: h,
                    weekendDisabled: C
                  }
                )
              }
            )
          ] })
        ]
      }
    );
  }
);
export {
  In as DatePicker
};
